import { Button, Collection, Flex, Loader } from "@aws-amplify/ui-react"
import type { AnimalGroupDto } from "@strtmn/sds/types"
import { Suspense, useContext } from "react"
import { FaCow, FaPenToSquare, FaXmark } from "react-icons/fa6"
import { Await, Link, useLoaderData, useParams } from "react-router-dom"
import config from "../../../config"
import { UserDataContext, UserDataContextHelper } from "../../../contexts"
import {
  getLinkToOrgAnimalGroup,
  getLinkToOrgAnimalGroups,
} from "../../../LinkUtils"
import GenauigkeitPerAnimalGroup from "../-components/GenauigkeitPerAnimalGroup"
import { imageHash } from "../-components/ListItem"
import RecipeItem from "../-components/RecipeItem"
import SecondaryListItem from "../-components/SecondaryListItem"

import "../RecipeManagement.css"

const NUM_AG_IMAGES = config.images.ag.numImages
const IMAGE_HASH_SEED = config.images.ag.imageHashSeed

export default function AnimalGroup() {
  const params = useParams()
  const { feedingStats } = useLoaderData() as { feedingStats: Promise<any> }

  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.findOrg(params["orgId"]!, userData!)
  const animalGroup: AnimalGroupDto = UserDataContextHelper.findAnimalGroup(
    org,
    params["animalGroupId"]!
  )

  const recipesFiltered = UserDataContextHelper.findRecipes(org).filter((r) => {
    let recipeContainsAg = false
    r.RecipesAusladegruppen.forEach((rag) => {
      if (rag.ausladegruppe_id === animalGroup.id) {
        recipeContainsAg = true
        return
      }
    })
    return recipeContainsAg
  })
  const imageIdx = imageHash(IMAGE_HASH_SEED, animalGroup.id, NUM_AG_IMAGES)
  const imageSrc = `/images/ag/animals-pixabay-${imageIdx}.jpg`

  return (
    <>
      <div className="rm-view-page">
        <div
          className="hdr-img"
          style={{ backgroundImage: `url('${imageSrc}')` }}
        />
        <Link to="..">
          <Button className="button-close has-icon">
            <span role="img" aria-label="Schließen">
              <FaXmark />
            </span>
          </Button>
        </Link>
        <div className="content-overlay">
          <div className="header">
            <div className="info">
              {/** @todo: Make fav star clickable */}
              <h2>
                {animalGroup.name}
                {/* <FaRegStar />*/}
              </h2>
              <div className="basic-info">
                {animalGroup.number_of_animals} Tiere
              </div>
            </div>
            <Link to={getLinkToOrgAnimalGroup(org, animalGroup.id, true)}>
              <Button className="button-edit has-icon">
                <span role="img" aria-label="Bearbeiten">
                  <FaPenToSquare />
                </span>
              </Button>
            </Link>
          </div>

          <Flex className="!flex-col gap-4 md:!flex-row md:!gap-0">
            <SecondaryListItem
              title="Meine Rezepte"
              _className="w-full md:!w-1/2"
            >
              {recipesFiltered.length > 0 ? (
                <Collection
                  className="w-full !mt-8"
                  type="list"
                  direction="column"
                  items={recipesFiltered}
                >
                  {(item) => {
                    return (
                      <RecipeItem
                        className="!w-full !border-none"
                        key={item.id}
                        org={org}
                        item={item}
                        hideFavStar={true}
                        hasViewButton={false}
                      />
                    )
                  }}
                </Collection>
              ) : (
                <div className="list-item-grid">
                  {animalGroup.name} wird in keinem Rezept verwendet.
                </div>
              )}
            </SecondaryListItem>

            <Suspense
              fallback={
                <SecondaryListItem
                  title="Genauigkeit"
                  _className="!w-full md:!w-1/2"
                >
                  <Loader />
                </SecondaryListItem>
              }
            >
              <Await resolve={feedingStats}>
                {(resolvedFeedingStats) => (
                  <GenauigkeitPerAnimalGroup
                    _className="!w-full md:!w-1/2"
                    animalGroup={animalGroup}
                    feedingStats={resolvedFeedingStats}
                  />
                )}
              </Await>
            </Suspense>
          </Flex>
        </div>
      </div>

      {/* <small>* Die Icons "xmark (light)", "pen-to-square (light)" benötigen FontAwesome Pro, kostet 49,- oder 99,- pro Jahr.</small> */}
    </>
  )
}

export const Component = AnimalGroup

export const ErrorComponent = () => {
  const params = useParams()
  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.findOrg(params["orgId"]!, userData!)

  const icon = <FaCow className="w-5 _h-3.5_ relativ text-[#3E9E29]" />
  const title = "Ausladestellen"
  return (
    <>
      <div className="rm-list-page">
        <Flex className="!h-12 !pb-2 !justify-between !items-center">
          <Flex className="!h-6 !justify-start !items-center gap-3">
            {icon}
            <div className="text-xl font-semibold">{title}</div>
          </Flex>
        </Flex>

        <div className="error mb-4 pl-2">
          Fehler: Ausladestelle nicht gefunden.
        </div>

        <Link to={getLinkToOrgAnimalGroups(org)}>
          <Button>Zurück zur Liste</Button>
        </Link>
      </div>
    </>
  )
}
